import styled from "styled-components";
import Content from "../components/content";
import { Box, TablePagination } from "@mui/material";
import { useMessages } from "../global/messagesContext";
import Loader from "../components/loader";
import { useState } from "react";

const Holder = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    overflow: auto;
`;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: #E4E4E4;
`;


const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-bottom: 24px;
`;

const ContainerMessage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

const DateText = styled.p`
    color: #000;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 16px;
`;

const Description = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    max-width: 60ch;
    word-wrap: break-word;
    white-space: pre-line;
`;

const Title = styled.p`
    margin-bottom: 12px;
    margin-top: 24px;
    color: #419392;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
    max-width: 72ch;
    word-wrap: break-word;
`;

export default function Notice() {
    const { data, loading } = useMessages();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const values = data || [];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${day}/${month}/${year} - ${hours}:${minutes}`;
    };

    return (
        <>
            {loading && <Loader />}
            <Holder>
                <Content title="Avisos">
                    <Box style={{ marginBottom: 20 }}>
                        <Container>
                            {values
                            ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            ?.map((item, index) => (
                                <ContainerMessage key={index}>
                                    <Divider />
                                    <Title>{item.title}</Title>
                                    <DateText>{formatDate(item.createdAt)}</DateText>
                                    <Description>{item.message}</Description>
                                </ContainerMessage>
                            ))}
                        </Container>
                        {values.length > 10 && (
                            <>
                                <Divider />
                                <TablePagination
                                    style={{ marginTop: 24 }}
                                    component="div"
                                    count={values.length}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    rowsPerPageOptions={[10, 25, 50]}
                                />
                            </>
                        )}
                    </Box>
                </Content>
            </Holder>
        </>
    );
}
